import debounce from 'lodash/debounce';
import {DebounceSettings} from 'lodash';

export function Debounce(wait: number = 500, immediate: boolean = false) {
  return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    const originalValue = descriptor.value;

    const debounceOption: DebounceSettings = {
      leading: immediate,
      trailing: !immediate
    };

    descriptor.value = debounce(originalValue, wait, debounceOption);

    return descriptor;
  };
}
